import { useEffect, useState } from 'react'
import api from '../api/client'
import { successModal, errorModal, confirmModal } from '../components/ui'
import Loader from '../components/Loader'

// Grupos de campos financeiros do serviço (visíveis quando "Regra própria" está ligada).
const GRUPOS = [
  ['Comissão Direta', [
    ['com_direta_pct', '% sobre a base'], ['com_direta_fixo', 'Valor fixo (R$)'],
    ['com_direta_min', 'Valor mínimo (R$)'], ['com_direta_max', 'Valor máximo (R$)'],
  ]],
  ['Comissão Indireta (rede)', [
    ['com_indireta_pct', '% por nível'], ['com_indireta_fixo', 'Valor fixo (R$)'],
    ['com_indireta_niveis', 'Quantidade de níveis'],
  ]],
  ['Recorrência Direta', [
    ['ro_direta_pct', '% sobre a recorrência'], ['ro_direta_fixo', 'Valor fixo (R$)'],
  ]],
  ['Recorrência Indireta', [
    ['ro_indireta_pct', '% por nível'], ['ro_indireta_fixo', 'Valor fixo (R$)'],
    ['ro_indireta_niveis', 'Quantidade de níveis'],
  ]],
  ['Bônus de Liderança', [
    ['bonus_lideranca_pct', '%'], ['bonus_lideranca_niveis', 'Níveis'],
    ['bonus_lideranca_status_min', 'Status (ordem faixa) mín.'],
  ]],
  ['Bônus de Expansão', [
    ['bonus_recrut_valor', 'Valor direto (R$)'], ['bonus_recrut_pct', '% direto'], ['bonus_recrut_niveis', 'Níveis indireta'],
  ]],
  ['Cashback', [
    ['cashback_pct', '%'], ['cashback_valor', 'Valor (R$)'],
  ]],
  ['Pontuação (PV)', [
    ['pv_direto', 'PV direto'], ['pv_indireto', 'PV indireto'],
    ['pv_multiplicador', 'Multiplicador'], ['pv_min', 'PV mínimo'], ['pv_max', 'PV máximo'],
  ]],
]
const BOOLS = [
  ['bonus_lideranca_corte', 'Regra de corte (paga só a diferença)'],
  ['bonus_lideranca_compressao', 'Compressão dinâmica (pula não elegível)'],
]

function Num({ label, value, onChange }) {
  return (
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>
      <input type="number" step="any" value={value ?? ''} onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400" />
    </div>
  )
}

function EditorServico({ srv, eventos, onSaved }) {
  const [f, setF] = useState({ ...srv })
  const [nota, setNota] = useState('')
  const [versoes, setVersoes] = useState(null)
  useEffect(() => { setF({ ...srv }); setNota(''); setVersoes(null) }, [srv])
  const set = (k) => (v) => setF({ ...f, [k]: v })

  async function salvar() {
    try {
      const body = { ...f, descricao_alteracao: nota || 'Regra atualizada' }
      const { data } = f.id ? await api.put(`/motor-remuneracao/servicos/${f.id}`, body)
                            : await api.post('/motor-remuneracao/servicos', body)
      successModal('Regra do serviço salva! Versão ' + (data.versao ?? ''))
      onSaved(data)
    } catch (e) { errorModal(e?.response?.data?.detail || 'Erro ao salvar') }
  }
  async function verVersoes() {
    if (!f.id) return
    try { const { data } = await api.get(`/motor-remuneracao/servicos/${f.id}/versoes`); setVersoes(data.data || []) }
    catch { setVersoes([]) }
  }

  const propria = f.usa_regra_faixa === false
  return (
    <div className="space-y-5">
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Nome do serviço</label>
            <input value={f.nome ?? ''} onChange={(e) => set('nome')(e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Slug (identificador)</label>
            <input value={f.slug ?? ''} disabled={!!f.id} onChange={(e) => set('slug')(e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400 disabled:bg-gray-50 disabled:text-gray-500" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Evento gerador</label>
            <select value={f.evento_gerador ?? ''} onChange={(e) => set('evento_gerador')(e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400 bg-white">
              <option value="">— nenhum —</option>
              {eventos.map((ev) => <option key={ev.slug} value={ev.slug}>{ev.nome}</option>)}
            </select>
          </div>
          <Num label="Ordem" value={f.ordem} onChange={set('ordem')} />
        </div>
        <div className="mt-4 flex flex-wrap gap-5">
          <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
            <input type="checkbox" checked={!!f.ativo} onChange={(e) => set('ativo')(e.target.checked)} className="w-4 h-4 accent-accent-500" /> Ativo
          </label>
          <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
            <input type="checkbox" checked={f.usa_regra_faixa !== false} onChange={(e) => set('usa_regra_faixa')(e.target.checked)} className="w-4 h-4 accent-accent-500" />
            Herdar percentuais da Faixa (Plano de Carreira)
          </label>
        </div>
        {!propria && (
          <p className="mt-3 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
            Este serviço usa os percentuais da FAIXA do licenciado (comportamento atual). Desmarque "Herdar percentuais da Faixa" para definir a regra PRÓPRIA deste serviço.
          </p>
        )}
      </div>

      {propria && GRUPOS.map(([titulo, campos]) => (
        <div key={titulo} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
          <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-3">{titulo}</p>
          <div className="grid sm:grid-cols-3 gap-4">
            {campos.map(([k, label]) => <Num key={k} label={label} value={f[k]} onChange={set(k)} />)}
          </div>
          {titulo === 'Bônus de Liderança' && (
            <div className="mt-4 flex flex-wrap gap-5">
              {BOOLS.map(([k, label]) => (
                <label key={k} className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
                  <input type="checkbox" checked={f[k] !== false} onChange={(e) => set(k)(e.target.checked)} className="w-4 h-4 accent-accent-500" /> {label}
                </label>
              ))}
            </div>
          )}
          {titulo === 'Pontuação (PV)' && (
            <div className="mt-4">
              <label className="block text-xs font-medium text-gray-600 mb-1">Regra de PV</label>
              <select value={f.pv_regra ?? ''} onChange={(e) => set('pv_regra')(e.target.value)}
                className="w-full sm:w-64 border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400 bg-white">
                <option value="">fixa (usa PV direto)</option>
                <option value="valor">valor (R$ = PV)</option>
                <option value="valor_mult">valor × multiplicador</option>
              </select>
            </div>
          )}
        </div>
      ))}

      <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
        <label className="block text-xs font-medium text-gray-600 mb-1">Descrição da alteração (fica no histórico de versões)</label>
        <input value={nota} onChange={(e) => setNota(e.target.value)} placeholder="Ex.: ajuste da comissão direta para 10%"
          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400" />
        <div className="mt-3 flex items-center gap-3">
          <button onClick={salvar} className="rounded-xl bg-gradient-to-r from-primary-500 to-accent-500 text-white px-6 py-2.5 font-semibold shadow-md hover:brightness-95">
            {f.id ? `Salvar (v${(f.versao ?? 1) + 1})` : 'Criar serviço'}
          </button>
          {f.id && <button onClick={verVersoes} className="text-sm text-gray-600 hover:text-gray-900 underline">Ver histórico de versões</button>}
          {f.id && <span className="text-xs text-gray-400">versão atual: v{f.versao ?? 1}</span>}
        </div>
      </div>

      {versoes && (
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
          <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-3">Histórico de versões</p>
          {versoes.length === 0 ? <p className="text-sm text-gray-500">Sem versões registradas.</p> : (
            <div className="space-y-2">
              {versoes.map((v, i) => (
                <div key={i} className="flex items-start justify-between text-sm border-b border-gray-100 pb-2">
                  <div><span className="font-semibold">v{v.versao}</span> — {v.descricao}
                    <div className="text-xs text-gray-400">{v.usuario} · {v.data ? new Date(v.data).toLocaleString('pt-BR') : ''} · IP {v.ip || '—'}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

function Simulador({ servicos }) {
  const [f, setF] = useState({ servico_slug: servicos[0]?.slug || '', valor: 200, pv: '', equipe: 3, clientes: 5, recorrencia: 0 })
  const [res, setRes] = useState(null)
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value })
  async function simular() {
    try {
      const body = { servico_slug: f.servico_slug, valor: Number(f.valor || 0), equipe: Number(f.equipe || 0),
        clientes: Number(f.clientes || 0), recorrencia: Number(f.recorrencia || 0) }
      if (f.pv !== '' && f.pv != null) body.pv = Number(f.pv)
      const { data } = await api.post('/motor-remuneracao/simular', body); setRes(data)
    } catch (e) { errorModal(e?.response?.data?.detail || 'Erro ao simular') }
  }
  const money = (v) => `R$ ${Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
  return (
    <div className="grid lg:grid-cols-2 gap-5">
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 space-y-4">
        <p className="text-xs font-bold uppercase tracking-wider text-gray-400">Parâmetros da simulação</p>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Serviço</label>
          <select value={f.servico_slug} onChange={set('servico_slug')} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white outline-none focus:border-accent-400">
            {servicos.map((s) => <option key={s.slug} value={s.slug}>{s.nome}</option>)}
          </select>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {[['valor', 'Valor da venda (R$)'], ['pv', 'PV pessoal (opcional)'], ['equipe', 'Equipe (nº pessoas)'], ['clientes', 'Clientes diretos'], ['recorrencia', 'Recorrência mensal (R$)']].map(([k, label]) => (
            <div key={k}>
              <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>
              <input type="number" step="any" value={f[k]} onChange={set(k)} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400" />
            </div>
          ))}
        </div>
        <button onClick={simular} className="rounded-xl bg-gradient-to-r from-primary-500 to-accent-500 text-white px-6 py-2.5 font-semibold shadow-md hover:brightness-95">Simular</button>
      </div>
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
        <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-3">Resultado (sem gravar)</p>
        {!res ? <p className="text-sm text-gray-500">Preencha os parâmetros e clique em Simular.</p> : (
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Status (faixa)</span>
              <span className="font-semibold" style={{ color: res.status_cor || undefined }}>{res.status}</span>
            </div>
            {[['Comissão direta', res.comissao_direta], ['Comissão indireta', res.comissao_indireta],
              ['Recorrência', res.recorrencia], ['Cashback', res.cashback]].map(([l, v]) => (
              <div key={l} className="flex items-center justify-between text-sm"><span className="text-gray-600">{l}</span><span>{money(v)}</span></div>
            ))}
            <div className="flex items-center justify-between text-sm"><span className="text-gray-600">Pontuação (PV)</span><span>{res.pontuacao}</span></div>
            {res.premiacao && <div className="flex items-center justify-between text-sm"><span className="text-gray-600">Premiação</span><span>{res.premiacao}</span></div>}
            <div className="flex items-center justify-between pt-3 border-t border-gray-100">
              <span className="font-semibold text-gray-800">Wallet estimada</span>
              <span className="text-lg font-extrabold text-emerald-600">{money(res.wallet_estimada)}</span>
            </div>
            <p className="text-xs text-gray-400">{res.usa_regra_faixa ? 'Regra herdada da Faixa' : 'Regra própria do serviço'}</p>
          </div>
        )}
      </div>
    </div>
  )
}

const IMPACTOS = [['wallet', 'Wallet'], ['pv', 'PV'], ['ranking', 'Ranking'], ['campanhas', 'Campanhas'], ['plano', 'Plano'], ['apenas_financeiro', 'Apenas Financeiro']]

function Ajustes({ servicos }) {
  const vazio = { licenciado_id: '', operacao: 'adicionar', alvo: 'comissao', valor: '', servico_slug: '', motivo: '', descricao: '', documento_url: '', observacao: '', impacto: {}, reprocessar_rede: false }
  const [f, setF] = useState(vazio)
  const [lista, setLista] = useState([])
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value })
  async function carregar() { try { const { data } = await api.get('/motor-remuneracao/ajustes'); setLista(data.data || []) } catch {} }
  useEffect(() => { carregar() }, [])
  async function enviar() {
    if (!f.licenciado_id || !f.motivo) { errorModal('Informe o licenciado e o motivo (obrigatório).'); return }
    const ok = await confirmModal('Confirmar ajuste administrativo? A operação é registrada em auditoria e não pode ser apagada.')
    if (!ok) return
    try {
      await api.post('/motor-remuneracao/ajustes', { ...f, licenciado_id: String(f.licenciado_id).trim(), valor: Number(f.valor || 0) })
      successModal('Ajuste registrado.'); setF(vazio); carregar()
    } catch (e) { errorModal(e?.response?.data?.detail || 'Erro ao registrar ajuste') }
  }

  // Importação em massa (Excel/CSV)
  const [impFile, setImpFile] = useState(null)
  const [impCsv, setImpCsv] = useState('')
  const [impRes, setImpRes] = useState(null)
  const [impBusy, setImpBusy] = useState(false)
  async function importar(dryRun) {
    if (!impFile && !impCsv.trim()) { errorModal('Selecione um arquivo .xlsx/.csv ou cole o CSV.'); return }
    if (!dryRun) {
      const ok = await confirmModal(`Aplicar ${impRes?.validas ?? 0} ajuste(s) em massa? A operação é auditada e não pode ser desfeita.`)
      if (!ok) return
    }
    const fd = new FormData()
    if (impFile) fd.append('arquivo', impFile)
    if (impCsv.trim()) fd.append('csv_texto', impCsv)
    fd.append('dry_run', dryRun ? 'true' : 'false')
    setImpBusy(true)
    try {
      const { data } = await api.post('/motor-remuneracao/ajustes/importar', fd)
      setImpRes(data)
      if (!dryRun) { successModal(`Importação: ${data.aplicados} aplicado(s), ${data.erros} erro(s).`); setImpFile(null); setImpCsv(''); carregar() }
    } catch (e) { errorModal(e?.response?.data?.detail || 'Erro na importação') }
    finally { setImpBusy(false) }
  }

  return (
    <div className="space-y-5">
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 space-y-4">
        <p className="text-xs font-bold uppercase tracking-wider text-gray-400">Novo ajuste (Administrador Master)</p>
        <div className="grid sm:grid-cols-4 gap-4">
          <div><label className="block text-xs font-medium text-gray-600 mb-1">ID, código (TC-…) ou CPF do licenciado</label>
            <input type="text" value={f.licenciado_id} onChange={set('licenciado_id')} placeholder="Ex.: 123, TC-3QYLUQ5 ou 269.869.278-27" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400" /></div>
          <div><label className="block text-xs font-medium text-gray-600 mb-1">Operação</label>
            <select value={f.operacao} onChange={set('operacao')} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white outline-none focus:border-accent-400">
              <option value="adicionar">Adicionar</option><option value="remover">Remover</option><option value="corrigir">Corrigir</option></select></div>
          <div><label className="block text-xs font-medium text-gray-600 mb-1">Alvo</label>
            <select value={f.alvo} onChange={set('alvo')} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white outline-none focus:border-accent-400">
              {['comissao', 'bonus', 'pv', 'wallet', 'cashback', 'recorrencia', 'vq', 'vt'].map((a) => <option key={a} value={a}>{a.toUpperCase()}</option>)}</select></div>
          <div><label className="block text-xs font-medium text-gray-600 mb-1">Valor</label>
            <input type="number" step="any" value={f.valor} onChange={set('valor')} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400" /></div>
          <div><label className="block text-xs font-medium text-gray-600 mb-1">Serviço (opcional)</label>
            <select value={f.servico_slug} onChange={set('servico_slug')} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white outline-none focus:border-accent-400">
              <option value="">—</option>{servicos.map((s) => <option key={s.slug} value={s.slug}>{s.nome}</option>)}</select></div>
          <div className="sm:col-span-3"><label className="block text-xs font-medium text-gray-600 mb-1">Motivo (obrigatório)</label>
            <input value={f.motivo} onChange={set('motivo')} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400" /></div>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className="block text-xs font-medium text-gray-600 mb-1">Descrição</label>
            <textarea rows={2} value={f.descricao} onChange={set('descricao')} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400" /></div>
          <div><label className="block text-xs font-medium text-gray-600 mb-1">Documento (URL) / Observação</label>
            <input value={f.documento_url} onChange={set('documento_url')} placeholder="URL do documento" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400 mb-2" />
            <input value={f.observacao} onChange={set('observacao')} placeholder="Observação" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400" /></div>
        </div>
        <div>
          <p className="text-xs font-medium text-gray-600 mb-2">Impacto (o que atualizar)</p>
          <div className="flex flex-wrap gap-4">
            {IMPACTOS.map(([k, label]) => (
              <label key={k} className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
                <input type="checkbox" checked={!!f.impacto[k]} onChange={(e) => setF({ ...f, impacto: { ...f.impacto, [k]: e.target.checked } })} className="w-4 h-4 accent-accent-500" /> {label}
              </label>
            ))}
          </div>
        </div>
        <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
          <input type="checkbox" checked={f.reprocessar_rede} onChange={(e) => setF({ ...f, reprocessar_rede: e.target.checked })} className="w-4 h-4 accent-accent-500" />
          Reprocessar rede (por padrão o ajuste NÃO recalcula a rede)
        </label>
        <button onClick={enviar} className="rounded-xl bg-gradient-to-r from-primary-500 to-accent-500 text-white px-6 py-2.5 font-semibold shadow-md hover:brightness-95">Registrar ajuste</button>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 space-y-3">
        <p className="text-xs font-bold uppercase tracking-wider text-gray-400">Importar em massa (Excel/CSV)</p>
        <p className="text-xs text-gray-500">Colunas: <span className="font-mono">licenciado_id, operacao, alvo, valor, servico_slug, motivo, reprocessar_rede, impacto</span>. Envie um <b>.xlsx/.csv</b> ou cole o CSV. A prévia valida cada linha antes de aplicar.</p>
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Arquivo (.xlsx ou .csv)</label>
            <input type="file" accept=".csv,.xlsx,.xlsm" onChange={(e) => { setImpFile(e.target.files?.[0] || null); setImpRes(null) }} className="w-full text-sm" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">…ou cole o CSV (com cabeçalho)</label>
            <textarea rows={3} value={impCsv} onChange={(e) => { setImpCsv(e.target.value); setImpRes(null) }}
              placeholder={'licenciado_id,operacao,alvo,valor,motivo\n1,adicionar,pv,100,bonus mensal'}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm font-mono outline-none focus:border-accent-400" />
          </div>
        </div>
        <div className="flex items-center gap-3 flex-wrap">
          <button onClick={() => importar(true)} disabled={impBusy}
            className="rounded-xl border border-accent-300 text-accent-600 px-4 py-2 text-sm font-semibold hover:bg-accent-50 disabled:opacity-50">Pré-visualizar</button>
          {impRes && impRes.validas > 0 && (
            <button onClick={() => importar(false)} disabled={impBusy}
              className="rounded-xl bg-gradient-to-r from-primary-500 to-accent-500 text-white px-4 py-2 text-sm font-semibold shadow-md hover:brightness-95 disabled:opacity-50">Aplicar {impRes.validas} válido(s)</button>
          )}
          {impRes && <span className="text-xs text-gray-500">{impRes.total} linha(s) · {(impRes.validas ?? impRes.aplicados) || 0} ok · {impRes.erros} erro(s)</span>}
        </div>
        {impRes && (
          <div className="overflow-x-auto max-h-64 overflow-y-auto border border-gray-100 rounded-lg">
            <table className="w-full text-sm">
              <thead className="sticky top-0 bg-gray-50"><tr className="text-left text-xs text-gray-400">
                <th className="py-2 px-2">#</th><th>Licenciado</th><th>Operação</th><th>Alvo</th><th>Valor</th><th>Status</th></tr></thead>
              <tbody>
                {impRes.linhas.map((r) => (
                  <tr key={r.linha} className="border-t border-gray-50">
                    <td className="py-1.5 px-2 text-gray-400">{r.linha}</td>
                    <td>{r.licenciado_nome ? `${r.licenciado_id} — ${r.licenciado_nome}` : r.licenciado_id}</td>
                    <td>{r.operacao}</td><td className="uppercase">{r.alvo}</td>
                    <td>{r.delta != null ? Number(r.delta).toFixed(2) : r.valor}</td>
                    <td>{r.status === 'ok'
                      ? <span className="text-emerald-600 font-medium">ok</span>
                      : <span className="text-red-600" title={r.erro}>erro: {r.erro}</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
        <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-3">Últimos ajustes (auditoria)</p>
        {lista.length === 0 ? <p className="text-sm text-gray-500">Nenhum ajuste registrado.</p> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-xs text-gray-400 border-b border-gray-100">
                <th className="py-2">Data</th><th>Lic.</th><th>Operação</th><th>Alvo</th><th>Valor</th><th>Motivo</th><th>Por</th></tr></thead>
              <tbody>
                {lista.map((r) => (
                  <tr key={r.id} className="border-b border-gray-50">
                    <td className="py-2 text-gray-500">{r.data ? new Date(r.data).toLocaleString('pt-BR') : ''}</td>
                    <td>{r.licenciado_id}</td><td>{r.operacao}</td><td className="uppercase">{r.alvo}</td>
                    <td className={Number(r.valor) < 0 ? 'text-red-600' : 'text-emerald-600'}>{Number(r.valor).toFixed(2)}</td>
                    <td className="max-w-xs truncate" title={r.motivo}>{r.motivo}</td><td className="text-gray-500">{r.usuario}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}

// ───────────── Configuração do Bônus de Liderança (matriz por serviço × status) — PRD 04-08-26 ─────────────
function BonusLideranca({ servicos }) {
  const [sid, setSid] = useState('')
  const [cfg, setCfg] = useState(null)
  const [loading, setLoading] = useState(false)
  const [fech, setFech] = useState(null)
  const [mes, setMes] = useState('')

  async function abrir(id) {
    setSid(id); setCfg(null); setFech(null)
    if (!id) return
    setLoading(true)
    try { const { data } = await api.get(`/motor-remuneracao/servicos/${id}/matriz-lideranca`); setCfg(data) }
    catch (e) { errorModal(e?.response?.data?.detail || 'Erro') } finally { setLoading(false) }
  }
  function setRow(i, k, v) { const m = [...cfg.matriz]; m[i] = { ...m[i], [k]: v }; setCfg({ ...cfg, matriz: m }) }
  async function salvar() {
    try { await api.put(`/motor-remuneracao/servicos/${sid}/matriz-lideranca`, { usa_matriz_lideranca: cfg.usa_matriz_lideranca, matriz: cfg.matriz })
      successModal('Matriz de Liderança salva!') }
    catch (e) { errorModal(e?.response?.data?.detail || 'Erro ao salvar') }
  }
  async function processar(aplicar) {
    if (aplicar && !(await confirmModal('Gerar as comissões PRÉVIA de Bônus de Liderança do mês? (liberadas no fechamento do admin)'))) return
    try {
      const q = new URLSearchParams({ ...(mes ? { mes } : {}), aplicar: String(!!aplicar) }).toString()
      const { data } = await api.post(`/motor-remuneracao/fechamento/bonus-lideranca?${q}`); setFech(data)
      if (aplicar) successModal(`Fechamento aplicado: ${data.beneficiados} beneficiados · R$ ${Number(data.total_valor).toFixed(2)}`)
    } catch (e) { errorModal(e?.response?.data?.detail || 'Erro no processamento') }
  }
  const inp = 'border border-gray-200 rounded px-2 py-1 text-sm'

  return (
    <div className="space-y-4">
      <div className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-2 text-xs text-amber-800">
        O Bônus de Liderança usa SEMPRE o <b>Status Qualificado do Mês</b> (nunca o permanente) e só é processado no <b>Fechamento do Ciclo</b>. Cada serviço tem sua própria matriz.
      </div>
      <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 flex items-end gap-3 flex-wrap">
        <div className="min-w-[240px]"><label className="block text-xs font-medium text-gray-600 mb-1">Serviço</label>
          <select value={sid} onChange={(e) => abrir(e.target.value)} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white">
            <option value="">Selecione…</option>{servicos.map((s) => <option key={s.id} value={s.id}>{s.nome}</option>)}</select></div>
      </div>
      {loading && <div className="py-8 flex justify-center"><Loader text="Carregando..." /></div>}
      {cfg && (
        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100 space-y-3">
          <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
            <input type="checkbox" checked={!!cfg.usa_matriz_lideranca} onChange={(e) => setCfg({ ...cfg, usa_matriz_lideranca: e.target.checked })} className="w-4 h-4 accent-accent-500" />
            Usar a matriz de liderança deste serviço
          </label>
          <div className="overflow-x-auto border border-gray-100 rounded-xl">
            <table className="w-full text-sm">
              <thead className="bg-gray-50"><tr className="text-left text-xs text-gray-500">
                <th className="py-2 px-3">Status do Plano de Carreira</th><th className="px-2">% Liderança</th><th className="px-2">Até nível</th>
                <th className="px-2">Corte</th><th className="px-2">Compressão</th><th className="px-2 text-center">Ativo</th></tr></thead>
              <tbody>
                {cfg.matriz.map((r, i) => (
                  <tr key={r.status} className="border-t border-gray-50">
                    <td className="py-1.5 px-3 font-medium text-gray-700">{r.status}</td>
                    <td className="px-2"><input type="number" step="0.01" value={r.percentual} onChange={(e) => setRow(i, 'percentual', parseFloat(e.target.value) || 0)} className={inp + ' w-20'} /></td>
                    <td className="px-2"><input type="number" value={r.ate_nivel} onChange={(e) => setRow(i, 'ate_nivel', parseInt(e.target.value) || 0)} className={inp + ' w-16'} /></td>
                    <td className="px-2"><select value={r.corte} onChange={(e) => setRow(i, 'corte', e.target.value)} className={inp + ' bg-white'}>{cfg.corte_opcoes.map((o) => <option key={o.valor} value={o.valor}>{o.label}</option>)}</select></td>
                    <td className="px-2"><select value={r.compressao} onChange={(e) => setRow(i, 'compressao', e.target.value)} className={inp + ' bg-white'}>{cfg.compressao_opcoes.map((o) => <option key={o.valor} value={o.valor}>{o.label}</option>)}</select></td>
                    <td className="px-2 text-center"><input type="checkbox" checked={!!r.ativo} onChange={(e) => setRow(i, 'ativo', e.target.checked)} className="w-4 h-4 accent-emerald-500" /></td>
                  </tr>
                ))}
                {cfg.matriz.length === 0 && <tr><td colSpan={6} className="py-6 text-center text-gray-400">Cadastre os status no Plano de Carreira primeiro.</td></tr>}
              </tbody>
            </table>
          </div>
          <div className="flex justify-end"><button onClick={salvar} className="rounded-xl bg-gradient-to-r from-primary-500 to-accent-500 text-white px-5 py-2 text-sm font-semibold shadow-md hover:brightness-95">Salvar matriz</button></div>
        </div>
      )}
      <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100 space-y-3">
        <p className="font-heading font-semibold text-gray-900">Fechamento do Ciclo — Bônus de Liderança</p>
        <div className="flex items-end gap-3 flex-wrap">
          <div><label className="block text-xs font-medium text-gray-600 mb-1">Mês (YYYY-MM)</label>
            <input value={mes} onChange={(e) => setMes(e.target.value)} placeholder="atual" className="border border-gray-200 rounded-lg px-3 py-2 text-sm w-32" /></div>
          <button onClick={() => processar(false)} className="rounded-xl border border-accent-300 text-accent-600 px-4 py-2 text-sm font-semibold hover:bg-accent-50">Simular (prévia)</button>
          <button onClick={() => processar(true)} className="rounded-xl bg-gradient-to-r from-primary-500 to-accent-500 text-white px-4 py-2 text-sm font-semibold shadow-md hover:brightness-95">Aplicar (gera prévias)</button>
        </div>
        {fech && (
          <div className="text-sm">
            <p className="text-gray-600 mb-2">Mês <b>{fech.mes}</b> · serviços com matriz: {fech.servicos} · beneficiados: <b>{fech.beneficiados}</b> · total: <b>R$ {Number(fech.total_valor).toFixed(2)}</b> {fech.aplicado ? '· APLICADO' : '· (simulação)'}</p>
            <div className="overflow-x-auto border border-gray-100 rounded-xl max-h-72 overflow-y-auto">
              <table className="w-full text-xs">
                <thead className="bg-gray-50 sticky top-0"><tr className="text-left text-gray-500"><th className="py-1.5 px-2">Licenciado</th><th>Serviço</th><th>Status mês</th><th>%</th><th>Base PV</th><th>Valor</th></tr></thead>
                <tbody>{(fech.itens || []).map((it, i) => (
                  <tr key={i} className="border-t border-gray-50"><td className="py-1 px-2">{it.licenciado}</td><td>{it.servico}</td><td>{it.status_mes}</td><td>{it.percentual}%</td><td>{it.base_pv}</td><td>R$ {Number(it.valor).toFixed(2)}</td></tr>
                ))}
                {(fech.itens || []).length === 0 && <tr><td colSpan={6} className="py-4 text-center text-gray-400">Nenhum bônus gerado (confira serviço com matriz ativa + licenciados qualificados).</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}


export default function MotorRemuneracao() {
  const [tab, setTab] = useState('servicos')
  const [servicos, setServicos] = useState(null)
  const [eventos, setEventos] = useState([])
  const [sel, setSel] = useState(null)

  async function load() {
    try {
      const [s, e] = await Promise.all([api.get('/motor-remuneracao/servicos'), api.get('/motor-remuneracao/eventos')])
      setServicos(s.data.data || []); setEventos(e.data.data || [])
    } catch { setServicos([]) }
  }
  useEffect(() => { load() }, [])

  function onSaved() { setSel(null); load() }

  if (!servicos) return <div className="flex justify-center py-20"><Loader text="Carregando motor de remuneração..." /></div>

  return (
    <div className="max-w-5xl space-y-5">
      <div>
        <h1 className="text-2xl font-heading font-bold text-gray-900">Motor de Remuneração MLM</h1>
        <p className="text-gray-500 text-sm mt-1">Regras financeiras por SERVIÇO (comissão, recorrência, bônus, cashback, pontuação). Separado do Plano de Carreira (reconhecimento).</p>
      </div>

      <div className="flex gap-2 border-b border-gray-200">
        {[['servicos', 'Serviços & Regras'], ['lideranca', 'Bônus de Liderança'], ['simulador', 'Simulador'], ['ajustes', 'Ajustes Administrativos']].map(([k, l]) => (
          <button key={k} onClick={() => { setTab(k); setSel(null) }}
            className={`px-4 py-2 text-sm font-semibold border-b-2 -mb-px ${tab === k ? 'border-accent-500 text-accent-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>{l}</button>
        ))}
      </div>

      {tab === 'servicos' && !sel && (
        <div className="space-y-3">
          <div className="flex justify-end">
            <button onClick={() => setSel({ nome: '', slug: '', ordem: (servicos.length + 1), ativo: true, usa_regra_faixa: true, versao: 1 })}
              className="rounded-xl border border-accent-300 text-accent-600 px-4 py-2 text-sm font-semibold hover:bg-accent-50">+ Novo serviço</button>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            {servicos.map((s) => (
              <button key={s.id} onClick={() => setSel(s)} className="text-left bg-white rounded-2xl p-5 shadow-sm border border-gray-100 hover:border-accent-300 transition">
                <div className="flex items-center justify-between">
                  <span className="font-semibold text-gray-900">{s.nome}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${s.usa_regra_faixa ? 'bg-gray-100 text-gray-500' : 'bg-emerald-50 text-emerald-600'}`}>
                    {s.usa_regra_faixa ? 'Herda faixa' : 'Regra própria'}</span>
                </div>
                <div className="text-xs text-gray-400 mt-1">slug: {s.slug} · v{s.versao} · evento: {s.evento_gerador || '—'}</div>
              </button>
            ))}
          </div>
        </div>
      )}
      {tab === 'servicos' && sel && (
        <div>
          <button onClick={() => setSel(null)} className="text-sm text-gray-500 hover:text-gray-800 mb-3">&larr; Voltar aos serviços</button>
          <EditorServico srv={sel} eventos={eventos} onSaved={onSaved} />
        </div>
      )}
      {tab === 'lideranca' && <BonusLideranca servicos={servicos} />}
      {tab === 'simulador' && <Simulador servicos={servicos} />}
      {tab === 'ajustes' && <Ajustes servicos={servicos} />}
    </div>
  )
}
